'use strict';

const SV = require('server-vars');
const uri = require('../../utils/commonjs/uri');
const User = require('../../models/User');
const authModalLoader = require('../../../auth/authModalLoader').default;
const referrerHelpers = require('../../tracking/referrerHelpers');
const pageTypeHelper = require('../pageTypeHelper');
const {PAGE_TYPE, BROWSE_TYPES} = require('../../constants/pageTypes');
const VisitCountModel = require('../../tracking/models/VisitCountModel');
const postAuthLoader = require('../../../postAuth/postAuthLoader');
const abExperiments = require('../../abExperiments.es');
const type = 'loginModal';

let isAutoPromptEnabled = true;

const disableLoginPrompt = function disableLoginPrompt() {
    isAutoPromptEnabled = false;
};

/**
 * Checks page type.
 * @returns {boolean}
 */
const isAllowedPageType = function isAllowedPageType() {
    const isPdpPrintPage = SV.get('settings.isPrintPDP');
    const allowedPageTypes = [
        PAGE_TYPE.HOME,
        PAGE_TYPE.CREATOR,
        PAGE_TYPE.DEALER,
        PAGE_TYPE.PDP
    ];

    const isAllowedPage = pageTypeHelper.isPageType(allowedPageTypes, BROWSE_TYPES);

    return isAllowedPage && !isPdpPrintPage;
};

/**
 * should visitor be prompted to login?
 * @returns {boolean}
 */
const isBlocked = function isBlocked() {
    if (User && User.loggedIn() || uri.URL.queryKey.modal || !isAllowedPageType() || referrerHelpers.isPlaReferrer()) {
        return true;
    }
    return false;
};

/**
 * Checks limit
 * @returns {boolean}
 */
const shouldPromptLoginRegistration = function shouldPromptLoginRegistration(visitCountModel) {
    return (visitCountModel.get('session') === visitCountModel.get('regPromptLimit'));
};

/**
 * Fix for edge case where a user continually comes to the site from a source where we want to delay
 * showing the login modal. Checks if we are allowed to show a modal. If we aren't this pushes the modal to the
 * next page view.
 */
const checkModalEligibility = function checkModalEligibility(visitCountModel) {
    if (shouldPromptLoginRegistration(visitCountModel) && isBlocked()) {
        visitCountModel.increment('regPromptLimit');
        visitCountModel.save();
    }
};

const canAutoPromptUser = function canAutoPromptUser() {
    const visitCountModel = new VisitCountModel();

    checkModalEligibility(visitCountModel);

    const isModalBlocked = isBlocked();
    const shouldOpenModal = shouldPromptLoginRegistration(visitCountModel);

    return isAutoPromptEnabled && shouldOpenModal && !isModalBlocked;
};

const getActionAndFlow = function getActionAndFlow() {
    let action = authModalLoader.constants.REGISTER;
    let flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
    const ga = {};

    if (User.everLoggedIn()) {
        action = authModalLoader.constants.LOGIN;
        flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
    }
    if (User.everLoggedInAsTrade()) {
        flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
        ga.label = 'pageview limit reached - trade';
    }

    return {action, flow, ga};
};

/**
 * prompts visitor to register if it's due
 * @return {boolean} true if login prompted
 */
const openLoginModal = function openLoginModal() {
    const {action, flow, ga} = getActionAndFlow();

    if (action === authModalLoader.constants.REGISTER && flow === authModalLoader.constants.PAGEVIEW_LIMIT_FLOW) {
        postAuthLoader.autoPromptRegistration({ flow });
    } else {
        authModalLoader.show({
            action: action,
            flow: flow,
            ga: Object.assign({
                label: 'pageview limit reached'
            }, ga)
        });
    }
};

const noRegistrationTest = function noRegistrationTest() {
    setTimeout(function () {
        abExperiments.noRegistrationModal.reject();
    }, 800);

    return abExperiments.noRegistrationModal
        .then(() => {
            return Promise.resolve();
        })
        .catch(() => {
            openLoginModal();
            return Promise.resolve({success: true, type});
        });
};

/**
 * Checks condition for auto prompt user.
 * Opens modal if condition is satisfied.
 * Condition:
 * page view - 3,
 * home / browse / creator / pdp (not print) page type,
 * User is not logged in and AuthModal is not opened.
 *
 * @return {Promise}
 */
const loginPromptRule = function loginPromptRule() {
    if (canAutoPromptUser()) {
        if (abExperiments.noRegistrationModal) {
            return noRegistrationTest();
        } else {
            openLoginModal();
            return Promise.resolve({success: true, type});
        }
    }
    return Promise.resolve();
};

module.exports = {
    loginPromptRule: loginPromptRule,
    disableLoginPrompt: disableLoginPrompt
};



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/loginPromptRule.es.js